import { CreatePodcastSubscriptionResponse } from './types';

type CreatePodcastSubscriptionParameters = {
  webStationId: string;
  email: string;
  name: string;
  countryCode: string;
  addressZip: string;
  stripePaymentToken: string;
};

export async function createPodcastSubscription({
  webStationId,
  email,
  name,
  countryCode,
  stripePaymentToken,
  addressZip,
}: CreatePodcastSubscriptionParameters): Promise<CreatePodcastSubscriptionResponse> {
  try {
    const body = {
      email,
      name,
      token: {
        id: stripePaymentToken,
        card: {
          country: countryCode,
          address_zip: addressZip,
        },
      },
    };
    const response = await fetch(
      `/api/proxy/v3/podcastSubscriptions/webStationId:${webStationId}/subscribe`,
      {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(body),
      }
    );
    if (response.ok) {
      return response.json();
    }
    throw new Error('Could not create subscription.');
  } catch (err) {
    throw new Error(err.message);
  }
}
